import _ from 'lodash'
import React from 'react'
import { use, api } from 'xadmin'
import { DepartmentSelectField, DepartmentMultipleSelectField } from '../components/DepartmentSelect'
import SelectDepartment, { filterDepartment } from './SelectDepartment'

const DepartmentSelectComponent = (props) => {

  const { input, field, placeholder, defaultValue, multiple, treeCheckable, selectDepartment, initValue } = props
  const [ value, setValue ] = React.useState(input.value)

  React.useEffect(() => {
    if(defaultValue) {
      setValue(defaultValue || {})
      input.onChange(defaultValue || {})
    } else {
      if(initValue && !multiple) {
        api({ name: 'core/department' })
        .query({ fields: [ 'parent', 'name', 'icon', 'node' ] })
        .then(({ items }) => {
          if(items?.length) {
            let defaultItem;
            if(selectDepartment) {
              let arr = items.filter(item => selectDepartment.some(ele=> ele === item.id)) || []
              defaultItem = arr?.length ? arr[0] : {}
            } else {
              defaultItem = items[0] || {}
            }
            setValue(defaultItem)
            input.onChange(defaultItem)
          }
        })
      }
    }
  }, [ defaultValue, initValue, multiple, selectDepartment ])

  const onChange = (item) => {
    setValue(item)
    input.onChange(item)
  }

  return (
    <div>
      { multiple ? 
      <DepartmentMultipleSelectField project={[ 'parent', 'node']} {...props} input={{...input, value: value instanceof Array ? value : !_.isEmpty(value) ? [value] : [], onChange}} field={{...field, placeholder}} treeCheckable={treeCheckable} filterDepartment={filterDepartment} selectDepartment={selectDepartment} /> :
      <DepartmentSelectField project={[ 'parent', 'node']} {...props} input={{...input, value, onChange}} field={{...field, placeholder}} filterDepartment={filterDepartment} selectDepartment={selectDepartment}/>}
    </div>
  )
}

const paramSchema = {
  type: 'object',
  properties: {
    multiple: {
      type: 'boolean',
      title: '多选',
      field: {
        effect: ({ value }, form) => {
          setTimeout(() => {
            form.setFieldData('treeCheckable', { display: !!value })
          })
        }
      }
    },
    treeCheckable: {
      type: 'boolean',
      title: '复选框'
    },
    placeholder: {
      title: '提示文字',
      type: 'string',
      description: '选择器中的提示文本信息'
    },
    selectDepartment: {
      title: '选择部门',
      type: 'array',
      items: {},
      field: {
        component: SelectDepartment
      }
    },
    initValue: {
      title: '默认值',
      type: 'boolean',
      description: '勾选后默认选中第一项，如果初始值和默认值同时存在，以初始值为准'
    }
  }
}

const DepartmentSelectNode = {
  title: '部门选择器(资产)',
  category: '版本兼容',
  icon: require('./../icon/部门选择器.svg'),
  component: DepartmentSelectComponent,
  paramSchema: paramSchema,
  fieldWidget: true,
  initParam: { placeholder: '请选择部门' },
  initLayout: { width: 160, height: 40 }
}

export default DepartmentSelectNode
